import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="bg-white text-charcoal" data-id="element-44" data-mp="1nv1l2blse3ze">
      <div className="mx-auto max-w-xl px-3 py-5 sm:px-5" data-id="element-45" data-mp="2blf4jdqb2uid">
        <h2 id="faq" className="text-center font-anton text-2xl uppercase sm:text-3xl" data-id="element-46" data-mp="2flxv74ggpuiz">
          Preguntas frecuentes
        </h2>

        <div className="mt-2.5 space-y-1.5" data-id="element-47" data-mp="21u1679a3c0qt">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <Reveal key={faq.q} delay={i * 0.015} className={`rounded-lg border-2 ${isOpen ? 'border-wood' : 'border-charcoal/10'} bg-cream-light`} data-id="element-48" data-mp="2ujhupvulaxhr" data-mpi={i}>
                <h3 data-id="element-49" data-mp="1vq126o3pz1to">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-2.5 rounded-lg px-3 py-2 text-left" data-id="element-50" data-mp="1vnev0pkqqobz">
                    <span className="font-display text-sm font-bold leading-snug" data-id="element-51" data-mp="2fcfjkcnpgw2t">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={16} className={`flex-shrink-0 text-wood transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-52" data-mp="2ah06vo1fp67z" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-53" data-mp="p1ko8rnvvm5i">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-54" data-mp="p3p3g5r8g7l3">
                      <p className="px-3 pb-2 text-sm leading-snug text-charcoal/80" data-id="element-55" data-mp="3318ti0nr6qoc">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}